import React from 'react';

interface LeftPanelSkeletonProps {
  rows?: number;
  scale?: number;
}

const LeftPanelSkeleton: React.FC<LeftPanelSkeletonProps> = ({ rows = 10, scale = 1 }) => {
  const leftboxWidth = 280 * scale;
  const boxheight = 60 * scale;

  return (
    <div
      className="sticky left-0 z-30 bg-white dark:bg-tertiary-dark border-r border-gray-200 dark:border-[#374151]"
      style={{ zIndex: 25, boxShadow: '2px 0 4px rgba(0,0,0,0.1)', height: '100%', width: leftboxWidth }}
    >
      {/* Sticky RESOURCES header */}
      <div className="flex items-center justify-center bg-white dark:bg-secondary-dark border-t border-b border-r-2 border-gray-300 dark:border-[#374151] text-gray-700 dark:text-white sticky top-0 z-40 rounded-tr-xl shadow-md" style={{ minWidth: leftboxWidth + 1, height: 'calc(36px + 45px)' }}>
        <div className="h-5 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
      </div>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="relative border-r-2 dark:border-[#374151] border-b border-gray-300 dark:border-gray-600/50 transition-colors duration-150 bg-white dark:bg-secondary-dark"
          style={{ width: leftboxWidth + 1, height: boxheight, boxShadow: '2px 0 4px rgba(0,0,0,0.1)' }}
        >
          <div className="flex flex-col justify-center h-full p-3">
            <div className="h-4 w-32 bg-gray-200 dark:bg-gray-700 rounded mb-2 animate-pulse" />
            <div className="h-3 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LeftPanelSkeleton; 